import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import BusinessGlossary from "./BusinessGlossary";
import CDEDefinitions from "./CDEDefinitions";
import DataSources from "./DataSources";
import Domains from "./Domains";
import People from "./People";
import ReferenceData from "./ReferenceData";
import ReferenceSource from "./ReferenceData/ReferenceSource";

const DataManagement = ({ features }) => {
    const CLIENT_ROUTES = {
        People: {
            component: People,
            path: "people/*",
        },
        Domains: {
            component: Domains,
            path: "domains/*",
        },
        "CDE Definitions": {
            component: CDEDefinitions,
            path: "cde-definitions/*",
        },
        "Data Sources": {
            component: DataSources,
            path: "data-sources/*",
        },
        "Business Glossary": {
            component: BusinessGlossary,
            path: "business-glossary/*",
        },
        "Reference Data": {
            component: ReferenceData,
            path: "reference-data/*",
        },
        "Reference Sources": {
            component: ReferenceSource,
            path: "reference-sources/*",
        },
    };

    return (
        <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
    );
};

export default DataManagement;
